/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, total: NonNullable<unknown> }} Chat_Tool_Bulk_Approve_SelectedInputs */



/**
* | output |
* | --- |
* | "Approve {count} of {total}" |
*
* @param {Chat_Tool_Bulk_Approve_SelectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_approve_selected = /** @type {((inputs: Chat_Tool_Bulk_Approve_SelectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Approve_SelectedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} von ${i?.total} genehmigen`)
	return /** @type {LocalizedString} */ (`Approve ${i?.count} of ${i?.total}`)
});